import { useState } from 'react';

const faqs = [
  {
    category: '契約・料金について',
    icon: 'ri-coins-line',
    items: [
      {
        q: '初月980円キャンペーンとは何ですか？',
        a: '初めてご利用いただくお客様限定で、初月の月額料金を980円（税込）でご提供するお試しキャンペーンです。2ヶ月目以降は通常の月額9,800円（税込）となります。キャンペーン期間中でも、通常と同じサービス内容をご提供いたします。',
      },
      {
        q: '契約期間の縛りはありますか？',
        a: 'いつでも解約可能です。年間契約プランもございますが、月払いプランをお選びいただければ、1ヶ月単位でご利用いただけます。解約のお申し出は翌月分から適用となります。違約金等は一切発生しません。',
      },
      {
        q: '月額9,800円以外に追加料金はかかりますか？',
        a: '毎月の定期作業（60分）・点検・写真報告・電話相談はすべて月額料金に含まれています。ただし、大規模な修繕工事（屋根の葺き替え、外壁塗装など）は別途お見積もりとなります。小規模な補修（ネジの締め直し、コーキングの補修など）は月額内で対応いたします。',
      },
      {
        q: '支払い方法を教えてください。',
        a: '銀行振込・クレジットカード（VISA・Mastercard・JCB）・口座振替に対応しています。毎月末日締め、翌月10日払いとなります。詳しくはお問い合わせ時にご案内いたします。',
      },
    ],
  },
  {
    category: 'サービス内容について',
    icon: 'ri-tools-line',
    items: [
      {
        q: '毎月どんな作業をしてもらえますか？',
        a: '毎月1回・約60分の作業をご要望に合わせて選択いただけます。庭の草刈り・剪定、室内外の清掃、害虫駆除・予防処置、小規模補修などから、その月に最も必要な作業を優先して行います。定期点検（屋根・外壁・水回りの目視確認）は毎回実施します。',
      },
      {
        q: '害虫駆除はどんな虫に対応していますか？',
        a: 'ゴキブリ・ムカデ・アリ・クモ・ハチ（小型）・シロアリの予防処置に対応しています。水路沿いや山沿いのお宅でも実績多数です。大型のスズメバチの巣の除去は専門業者と連携して対応いたします（別途費用が発生する場合があります）。',
      },
      {
        q: '作業の報告はどのように届きますか？',
        a: '作業完了後、当日中にLINEで写真付きの報告をお送りします。作業内容・気になった箇所・次回への申し送り事項などを記載した報告書形式でお届けします。離れて暮らすご家族のLINEにも同時にお送りすることが可能です。',
      },
      {
        q: '緊急時（雨漏り・水道管破裂など）にも対応してもらえますか？',
        a: '契約中のお客様は、緊急時の電話相談を無料でご利用いただけます（0120-847-481）。状況に応じて緊急訪問対応も可能です（別途費用が発生する場合があります）。まずはお電話でご相談ください。',
      },
    ],
  },
  {
    category: '対応エリア・訪問について',
    icon: 'ri-map-pin-line',
    items: [
      {
        q: '対応エリアはどこですか？',
        a: '岡山県南部を中心に対応しています。岡山市・倉敷市・玉野市・総社市・浅口市・早島町・里庄町などが主な対応エリアです。上記以外のエリアについてもお気軽にご相談ください。場合によっては対応可能なこともあります。',
      },
      {
        q: '空き家・別荘の管理もお願いできますか？',
        a: 'はい、空き家・別荘・実家の管理も承っています。離れて暮らすご家族に代わって定期的に訪問し、建物の状態確認・換気・郵便物の確認・庭の管理などを行います。遠方にお住まいの方からのご依頼も多数いただいています。',
      },
      {
        q: '訪問スタッフは毎回同じ人ですか？',
        a: '基本的に担当スタッフを固定しています。顔なじみのスタッフが継続して訪問することで、家の状態の変化に気づきやすくなります。やむを得ず担当が変わる場合は、事前にご連絡いたします。',
      },
    ],
  },
  {
    category: 'はじめての方へ',
    icon: 'ri-question-line',
    items: [
      {
        q: '申し込みから利用開始までどのくらいかかりますか？',
        a: 'お問い合わせいただいてから、通常3〜5営業日以内に初回訪問が可能です。まずはお電話またはLINEでご連絡いただき、ご要望をお聞かせください。無料の現地確認を行った後、サービス開始となります。',
      },
      {
        q: '初回訪問時に何を準備しておけばいいですか？',
        a: '特別な準備は不要です。初回は現地確認を兼ねて、お客様のご要望をじっくりお聞きします。気になる箇所や優先してほしい作業があれば、メモしておいていただけるとスムーズです。鍵の預かりについては、ご希望に応じて対応いたします。',
      },
      {
        q: 'まず相談だけでも大丈夫ですか？',
        a: 'もちろんです！相談・見積もりは完全無料で、しつこい営業は一切いたしません。「どんなことを頼めるの？」「うちの場合はいくらかかる？」といった気軽なご質問も大歓迎です。お電話（0120-847-481）またはお問い合わせフォームからお気軽にどうぞ。',
      },
    ],
  },
];

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section id="faq" aria-label="よくある質問 FAQ" className="py-20 md:py-28 bg-stone-50">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-amber-700 text-sm font-semibold tracking-widest mb-3 uppercase">
            よくある質問
          </span>
          <h2
            className="text-2xl md:text-4xl font-black text-stone-800 leading-tight"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            ご不安・ご疑問に<br />丁寧にお答えします
          </h2>
          <p className="mt-4 text-stone-500 text-sm md:text-base max-w-xl mx-auto">
            お申し込み前によく寄せられるご質問をまとめました。解決しない場合はお気軽にご連絡ください。
          </p>
        </div>

        {/* FAQ Categories */}
        <div className="flex flex-col gap-10">
          {faqs.map((cat) => (
            <div key={cat.category}>
              {/* Category Label */}
              <div className="flex items-center gap-2 mb-4">
                <div className="w-7 h-7 flex items-center justify-center bg-amber-100 rounded-full">
                  <i className={`${cat.icon} text-amber-600 text-sm`}></i>
                </div>
                <h3
                  className="text-stone-700 font-bold text-sm tracking-wide"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  {cat.category}
                </h3>
              </div>

              {/* Items */}
              <div className="flex flex-col gap-2">
                {cat.items.map((item, idx) => {
                  const id = `${cat.category}-${idx}`;
                  const isOpen = openId === id;
                  return (
                    <div
                      key={id}
                      className={`bg-white rounded-xl border transition-colors ${
                        isOpen ? 'border-amber-200' : 'border-stone-100'
                      }`}
                    >
                      <button
                        onClick={() => toggle(id)}
                        className="cursor-pointer w-full flex items-start gap-4 px-5 py-4 text-left"
                      >
                        <span
                          className={`shrink-0 w-6 h-6 flex items-center justify-center rounded-full text-xs font-black mt-0.5 transition-colors ${
                            isOpen
                              ? 'bg-amber-600 text-white'
                              : 'bg-amber-100 text-amber-700'
                          }`}
                        >
                          Q
                        </span>
                        <h4 className="flex-1 text-stone-800 font-semibold text-sm leading-snug">
                          {item.q}
                        </h4>
                        <span
                          className={`shrink-0 w-6 h-6 flex items-center justify-center transition-transform duration-300 ${
                            isOpen ? 'rotate-180' : ''
                          }`}
                        >
                          <i className="ri-arrow-down-s-line text-stone-400 text-lg"></i>
                        </span>
                      </button>

                      {/* Answer */}
                      <div
                        className={`overflow-hidden transition-all duration-300 ${
                          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                        }`}
                      >
                        <div className="flex gap-4 px-5 pb-5">
                          <span className="shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-stone-100 text-stone-500 text-xs font-black mt-0.5">
                            A
                          </span>
                          <p className="text-stone-600 text-sm leading-relaxed flex-1">
                            {item.a}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center bg-white rounded-2xl p-8 border border-stone-100">
          <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-full mx-auto mb-4">
            <i className="ri-customer-service-2-line text-amber-600 text-xl"></i>
          </div>
          <p
            className="text-stone-800 font-bold text-base md:text-lg mb-1"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            解決しないご質問はお気軽に
          </p>
          <p className="text-stone-500 text-sm mb-5">
            電話・LINEでも気軽にご相談いただけます。しつこい営業は一切いたしません。
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="tel:0120847481"
              className="cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2 bg-amber-600 hover:bg-amber-700 text-white font-bold px-7 py-3 rounded-full text-sm transition-colors"
            >
              <i className="ri-phone-line"></i>
              0120-847-481
            </a>
            <button
              onClick={() => {
                const el = document.getElementById('contact');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2 bg-white border border-stone-200 hover:bg-stone-50 text-stone-700 font-bold px-7 py-3 rounded-full text-sm transition-colors"
            >
              <i className="ri-mail-line"></i>
              メールで問い合わせ
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
